module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-close-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-close-up@3x.png
// module id = 625
// module chunks = 0